import $ from 'jquery';
// import {onResize} from "../utils/window";
import {dependency} from "../utils/request";
import init from "../init";

export default function newsPage() {
	const $html = $('html');
	const $scroller = $('html, body');
	const $newsPage = $('.news-page');

	if ($newsPage.length) {
		let loadButton = $newsPage.find('.news-page-load > a');
		dependency('https://unpkg.com/masonry-layout@4/dist/masonry.pkgd.min.js', () => window.Masonry && Masonry).then(function () {
			const $masonry = $('.masonry');

			$masonry.masonry({
				// options
				itemSelector: '.masonry .masonry-item',
				columnWidth: '.masonry .masonry-sizer',
				percentPosition: true
			});

			loadButton.click(function (e) {
				e.preventDefault();

				const $parent = loadButton.parent();
				$parent.addClass('-loading');

				const url = loadButton.attr('href');
				$.get(url, function (data) {
					const $loaded = $(data);
					const cells = $loaded.find('.masonry.grid > .cell.masonry-item');
					const loadedButton = $loaded.find('.news-page-load > a');

					$masonry.append(cells).masonry('appended', cells);

					init($masonry);

					if (loadedButton.length) {
						loadButton.attr('href', loadedButton.attr('href'));
						$parent.removeClass('-loading');
					} else {
						$parent.remove();
					}
				});
			});

		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/pages/news.js